import { render, staticRenderFns } from "./OrganizationsPendingRequests.vue?vue&type=template&id=7c115320&scoped=true"
import script from "./OrganizationsPendingRequests.vue?vue&type=script&lang=js"
export * from "./OrganizationsPendingRequests.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsPendingRequests.vue?vue&type=style&index=0&id=7c115320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c115320",
  null
  
)

export default component.exports